import { createContext } from "react";
import { EventSearchResponse } from "../../interfaces/eventSearchResponse";
import {
  EventLocations,
  EventMapLocations,
} from "../../interfaces/eventLocations";

export interface ContextProps {
  eventFindNearestSearch: boolean;
  eventLocations: EventLocations[] | [];
  eventMapLocations: EventMapLocations[] | [];
  eventTotalResults: number;

  clearEventLocations: () => void;
  setEventLocations: (eventSearchResponse: EventSearchResponse) => void;
  setMapEventLocations: (eventSearchResponse: EventSearchResponse) => void;
}

export const EventLocationsContext = createContext({} as ContextProps);
